import { Navigate } from 'react-router'
import { useAuth } from '@/lib/auth'

export function HomePage() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 dark:bg-zinc-950">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center text-white font-bold text-xl bg-primary-500 animate-pulse">
            F
          </div>
          <p className="text-zinc-500">Loading...</p>
        </div>
      </div>
    )
  }

  if (user) {
    return <Navigate to="/pipeline" replace />
  }

  return <Navigate to="/login" replace />
}
